export default __webpack_public_path__ + "static/productHeroOne-60ac57d9356598cf933fc651cb84de4d.png";